export class Fatura {
  id: number;
  uuid: string;
  idUnidadeFaturamento: string;
  periodoFaturamento: string;
  mesRederencia: number;
  anoReferencia: number;

  quantidadeConsulta: number;
  quantidadeConsultaMesAnterior: number;
  indicadorCrescimentoQuantidade: number;
  valorTotal: number;
  valorTotalMesAnterior: number;
  indicadorCrescimentoValor: number;
  totalClientes: number;
  totalClientesVerificados: number;
  totalClientesPendenteVerificacao: number;
  totalClientesnaofaturados: number;
  totalClientessemconsumo: number;

  constructor(fatura) {
    this.id = fatura['id'] || null;
    this.uuid = fatura['uuid'] || null;
    this.idUnidadeFaturamento = fatura['idUnidadeFaturamento'] || null;
    this.periodoFaturamento = fatura['periodoFaturamento'] || null;
    this.mesRederencia = fatura['mesRederencia'] || null;
    this.anoReferencia = fatura['anoReferencia'] || null;
    this.quantidadeConsulta = fatura['quantidadeConsulta'] || 0;
    this.quantidadeConsultaMesAnterior = fatura['quantidadeConsultaMesAnterior'] || 0;
    this.indicadorCrescimentoQuantidade = fatura['indicadorCrescimentoQuantidade'] || 0;
    this.valorTotal = fatura['valorTotal'] || 0;
    this.valorTotalMesAnterior = fatura['valorTotalMesAnterior'] || 0;
    this.indicadorCrescimentoValor = fatura['indicadorCrescimentoValor'] || 0;
    this.totalClientes = fatura['totalClientes'] || 0;
    this.totalClientesVerificados = fatura['totalClientesVerificados'] || 0;
    this.totalClientesPendenteVerificacao = fatura['totalClientesPendenteVerificacao'] || 0;
    this.totalClientesnaofaturados = fatura['totalClientesnaofaturados'] || 0;
    this.totalClientessemconsumo = fatura['totalClientessemconsumo'] || 0;
  }

}
